import * as React from "react";

import { CustomNormalizationHelper } from "../Engine/Core/Normalization/CustomNormalizationHelper";

import { useFormObject } from "./FormObjectProvider";
import { createHocDisplayName } from "./TypingUtils";

interface WithCustomNormalizationHelperInjectableProps {
    customNormalizationHelper: CustomNormalizationHelper;
}

export function withCustomNormalizationHelper<P extends WithCustomNormalizationHelperInjectableProps>(
    WrappedComponent: React.ComponentType<P>
): React.ComponentType<Omit<P, "customNormalizationHelper">> {
    function WithCustomNormalizationHelper(props: Omit<P, "customNormalizationHelper">): JSX.Element {
        const form = useFormObject();

        // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
        const newProps: P = {
            ...props,
            customNormalizationHelper: form.customNormalizationHelper,
        };

        return <WrappedComponent {...newProps} />;
    }
    WithCustomNormalizationHelper.displayName = createHocDisplayName(WrappedComponent, "customNormalizationHelper");
    return WithCustomNormalizationHelper;
}
